import { render, staticRenderFns } from "./DoorMaintenanceReportsList.vue?vue&type=template&id=a0b0cc58&"
import script from "./DoorMaintenanceReportsList.vue?vue&type=script&lang=js&"
export * from "./DoorMaintenanceReportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports